export default {"src":"/_next/static/media/KSS.9bf1b0b4.svg","height":18,"width":18};